// extracted by mini-css-extract-plugin
module.exports = {"block":"HighSchoolNav_block__eXz1T","grid":"HighSchoolNav_grid__H2XKD"};